import React from 'react';
import PreferencesIndex from "../../preferences";
export function preferencesRoutes() { return [{ path: '/preferences', element: /*#__PURE__*/ React.createElement(PreferencesIndex, null) }]; }
